import React from 'react';
import SectionTitle from '../../components/ConsultancyElements/SectionTitle';
import Service01Block from '../../components/ServiceElements/Service01Block';

const ServiceContainer01 = () => {
    const ServiceData = [
        {
            id: '1',
            icon01: 'images/services/icons/1-1.png',
            icon02: 'images/services/icons/1-2.png',
            bg: 'images/services/bg-1.png',
            bgHover: 'images/services/bg-hover-1.png',
            title: 'Admission & Enrollment',
            description: 'Fill seats faster with paperless, parent-friendly admissions and real-time enrollment analytics.'
        },
        {
            id: '2',
            icon01: 'images/services/icons/2-1.png',
            icon02: 'images/services/icons/2-2.png',
            bg: 'images/services/bg-1.png',
            bgHover: 'images/services/bg-hover-2.png',
            title: 'Student Information System (SIS)',
            description: 'A single source of truth for every learner—attendance, grades, behavior, fees, and compliance.'
        },
        {
            id: '3',
            icon01: 'images/services/icons/3-1.png',
            icon02: 'images/services/icons/3-2.png',
            bg: 'images/services/bg-1.png',
            bgHover: 'images/services/bg-hover-3.png',
            title: 'Academic Management',
            description: 'For a growing business firm we provide market research & competitor analysis before a product launch in market.'
        },
        {
            id: '4',
            icon01: 'images/services/icons/4-1.png',
            icon02: 'images/services/icons/4-2.png',
            bg: 'images/services/bg-1.png',
            bgHover: 'images/services/bg-hover-4.png',
            title: 'Academic Management',
            description: 'Plan, teach, assess, and remediate in one place, aligned to national and international standards.'
        },
        {
            id: '5',
            icon01: 'images/services/icons/5-1.png',
            icon02: 'images/services/icons/5-2.png',
            bg: 'images/services/bg-1.png',
            bgHover: 'images/services/bg-hover-5.png',
            title: 'Leadership Evaluation',
            description: 'For a growing business firm we provide market research & competitor analysis before a product launch in market.'
        },
        {
            id: '6',
            icon01: 'images/services/icons/6-1.png',
            icon02: 'images/services/icons/6-2.png',
            bg: 'images/services/bg-1.png',
            bgHover: 'images/services/bg-hover-6.png',
            title: 'Digital Marketing',
            description: 'No one can deny the importance of digital marketing now a days so we are providing this service also.'
        },

    ];

    return (
        <section className="services-section">
            <div className="container">
                <SectionTitle
                    title='Products/Solutions'
                    header='Design and delivery of future-ready international K-12 curricula for primary-, middle- and high school academic programs aligned with global and local priorities as well as joint academic program delivery through partnering with us.' />

                <div className="inner-column">
                    <div className="row clearfix">
                        {
                            ServiceData.map(data => <Service01Block
                                key={data.id}
                                data={data}
                            />)
                        }
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ServiceContainer01;